import React, { useState } from "react";
import { Button, Drawer } from "@mui/material";

import { ManagementFees } from "assets/material-custom-icons";
import { useAccountSelector } from "store";
import { Content } from "./Content";

export const Fees: React.FC = () => {
  const { allow_fees_calc } = useAccountSelector() || {};
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleClose = () => setIsOpen(false);

  if (!allow_fees_calc) return null;

  return (
    <>
      <Button onClick={() => setIsOpen(true)} startIcon={<ManagementFees />}>
        Fees
      </Button>
      <Drawer
        sx={{
          ".MuiPaper-root": {
            display: "flex",
            flexDirection: "column",
            width: 520,
            borderTopRightRadius: "25px",
            borderBottomRightRadius: "25px"
          }
        }}
        open={isOpen}
        onClose={handleClose}
      >
        <Content onClose={handleClose} />
      </Drawer>
    </>
  );
};
